/** @deprecated Create a class in the react/src/apis folder instead.*/
export class ApiBase {

    protected static baseConfig = {
	    headers: {
	        'Content-Type': 'application/json'
	    },
	    method: 'POST'
    };

    protected static baseUrl = '/';

    protected static async Get(endpoint: string, config?: RequestInit): Promise<Response>{

	    const headers = { ...this.baseConfig.headers, ...config?.headers };
	    return fetch(`${this.baseUrl}/${endpoint}`, { ...this.baseConfig, headers: headers });

    }

    protected static async Post(endpoint: string, data: any, config?: RequestInit): Promise<Response>{

	    const headers = { ...this.baseConfig.headers, ...config?.headers };
	    return fetch(`${this.baseUrl}/${endpoint}`, {
	        ...this.baseConfig,
	        body: JSON.stringify(data),
	        headers: headers
	    });

    }

}